import React, { useEffect, useRef } from 'react';
var useAbortController = function () {
    var _a;
    var acRef = useRef(new AbortController());
    var abort = React.useCallback(function (init) {
        var _a;
        if (init === void 0) { init = true; }
        (_a = acRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        // initalize new abort controller
        if (init) {
            acRef.current = new AbortController();
            return acRef.current;
        }
        return null;
    }, []);
    useEffect(function () {
        return function () {
            // cleanup old abort controller
            // dont initialize another one
            abort(false);
        };
    }, [abort]);
    return {
        abort: abort,
        signal: (_a = acRef === null || acRef === void 0 ? void 0 : acRef.current) === null || _a === void 0 ? void 0 : _a.signal,
    };
};
export default useAbortController;
